import React, { useState } from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import PaneHeader from '../../tools/panes/PaneHeader'

const ExportKMZTooltip = ({ uiStore, t, item, isTG = false }) => {
  const [selectedFormat, setSelectedFormat] = useState(uiStore.kmlFormat ? 'kml' : 'kmz')
  const [selectedShapesScope, setSelectedShapesScope] = useState(uiStore.kmlAllShapes === false ? 'outer_boundary' : 'all_shapes')
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (!item || isExporting) return
    setIsExporting(true)
    const isKml = selectedFormat === 'kml'
    const allShapes = selectedShapesScope === 'all_shapes'
    uiStore.kmlFormat = isKml
    uiStore.kmlAllShapes = allShapes

    try {
      if (typeof item.exportKml === 'function') {
        if (isTG) {
          await item.exportKml(isKml, allShapes)
        } else {
          await item.exportKml(isKml)
        }
      }
    } catch (err) {
      console.error('[ExportKMZTooltip] Export failed:', err)
    } finally {
      setIsExporting(false)
      uiStore.hideClickTooltip()
    }
  }

  return (
    <div
      id='export-kmz-tooltip'
      className='click-tooltip export-kmz-tooltip'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <PaneHeader
        title={t('GLOBAL.EXPORT_KML', { defaultValue: 'Export KML/KMZ' })}
        onClose={(e) => {
          if (e && e.stopPropagation) e.stopPropagation()
          if (!isExporting) uiStore.hideClickTooltip()
        }}
      />

      <p className='export-tooltip__desc'>
        {isTG
          ? t('GLOBAL.CHOOSE_SHAPES_AND_FORMAT', { defaultValue: 'Choose shapes to export and file format.' })
          : t('GLOBAL.CHOOSE_FILE_FORMAT', { defaultValue: 'Choose a file format to export.' })}
      </p>

      {isTG && (
        <div className='export-tooltip__section'>
          <div className='export-tooltip__section-title'>
            {t('GLOBAL.SHAPES_TO_EXPORT', { defaultValue: 'Shapes to export' })}
          </div>
          <div className='export-tooltip__options'>
            <div
              className={`export-tooltip__option ${selectedShapesScope === 'all_shapes' ? 'export-tooltip__option--selected' : ''}`}
              onClick={() => setSelectedShapesScope('all_shapes')}
            >
              <div className={`export-tooltip__radio ${selectedShapesScope === 'all_shapes' ? 'export-tooltip__radio--selected' : ''}`}>
                {selectedShapesScope === 'all_shapes' && <div className='export-tooltip__radio-dot' />}
              </div>
              <span className='export-tooltip__option-label'>
                {t('GLOBAL.EXPORT_ALL_SHAPES', { defaultValue: 'Export all shapes' })}
              </span>
            </div>

            <div
              className={`export-tooltip__option ${selectedShapesScope === 'outer_boundary' ? 'export-tooltip__option--selected' : ''}`}
              onClick={() => setSelectedShapesScope('outer_boundary')}
            >
              <div className={`export-tooltip__radio ${selectedShapesScope === 'outer_boundary' ? 'export-tooltip__radio--selected' : ''}`}>
                {selectedShapesScope === 'outer_boundary' && <div className='export-tooltip__radio-dot' />}
              </div>
              <span className='export-tooltip__option-label'>
                {t('GLOBAL.EXPORT_OUTER_BOUNDARY', { defaultValue: 'Export outer boundary' })}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className='export-tooltip__section'>
        {isTG && (
          <div className='export-tooltip__section-title'>
            {t('GLOBAL.FILE_FORMAT', { defaultValue: 'File format' })}
          </div>
        )}
        <div className='export-tooltip__options'>
          <div
            className={`export-tooltip__option ${selectedFormat === 'kml' ? 'export-tooltip__option--selected' : ''}`}
            onClick={() => setSelectedFormat('kml')}
          >
            <div className={`export-tooltip__radio ${selectedFormat === 'kml' ? 'export-tooltip__radio--selected' : ''}`}>
              {selectedFormat === 'kml' && <div className='export-tooltip__radio-dot' />}
            </div>
            <span className='export-tooltip__option-label'>KML</span>
          </div>

          <div
            className={`export-tooltip__option ${selectedFormat === 'kmz' ? 'export-tooltip__option--selected' : ''}`}
            onClick={() => setSelectedFormat('kmz')}
          >
            <div className={`export-tooltip__radio ${selectedFormat === 'kmz' ? 'export-tooltip__radio--selected' : ''}`}>
              {selectedFormat === 'kmz' && <div className='export-tooltip__radio-dot' />}
            </div>
            <span className='export-tooltip__option-label'>KMZ</span>
          </div>
        </div>
      </div>

      <div className='tooltip-actions'>
        <button
          type='button'
          className='btn-cancel'
          onClick={(e) => {
            e.stopPropagation()
            uiStore.hideClickTooltip()
          }}
          disabled={isExporting}
        >
          {t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}
        </button>
        <button
          type='button'
          className='btn-submit'
          disabled={!selectedFormat || isExporting}
          onClick={handleExport}
        >
          {isExporting ? t('GLOBAL.EXPORTING', { defaultValue: 'Exporting...' }) : t('GLOBAL.EXPORT', { defaultValue: 'Export' })}
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(inject('uiStore')(observer(ExportKMZTooltip)))
